import { Reveal } from "../site/Motion";
import StoreButtons from "../site/StoreButtons";
import WaitlistForm from "../site/WaitlistForm";

export const CTA = () => {
  return (
    <section id="waitlist" className="relative scroll-mt-24 bg-white py-24" data-testid="cta-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] bg-brand px-8 py-16 text-center shadow-2xl sm:px-16 sm:py-20">
            <div className="mesh-glow pointer-events-none absolute inset-0 opacity-70" />
            <div className="grid-lines pointer-events-none absolute inset-0 opacity-[0.08]" />
            <div className="relative mx-auto max-w-2xl">
              <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-white/80">
                <span className="h-1.5 w-1.5 rounded-full bg-greenaccent" /> Launch waitlist
              </span>
              <h2 className="mt-6 font-display text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl">
                Stop tracking renewals by memory.
              </h2>
              <p className="mt-5 text-lg text-white/75">
                Available now on Google Play. Join the waitlist to be first to know when we launch on the App Store.
              </p>

              <div className="mx-auto mt-9 max-w-lg">
                <WaitlistForm source="cta" variant="dark" />
                <p className="mt-3 text-xs text-white/60">No spam. We'll only email you about the App Store launch.</p>
              </div>

              <div className="mt-10 flex flex-col items-center gap-4">
                <span className="text-xs font-medium uppercase tracking-widest text-white/50">Get RenewTracker on</span>
                <StoreButtons size="lg" className="justify-center" />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CTA;
